import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserHistory } from 'history';
import {
  HistoryAdaptedRouter,
  IHistory4,
  useUuiServices,
  UuiContext,
} from '@epam/uui-core';
import { Snackbar, Modals } from '@epam/uui-components';
import { ErrorHandler } from '@epam/promo';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { App } from './App';
import svc from './services';
import { initializeTelemetry } from './telemetry';
import '@epam/uui-components/styles.css';
import '@epam/uui/styles.css';
import '@epam/promo/styles.css';

// Initialize OpenTelemetry before rendering the app
initializeTelemetry();

const history = createBrowserHistory();
const router = new HistoryAdaptedRouter(history as unknown as IHistory4);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 1000,
    },
  },
});

const UuiEnhancedApp = () => {
  const { services } = useUuiServices({ router });

  Object.assign(svc, services);

  return (
    <UuiContext.Provider value={services}>
      <ErrorHandler>
        <QueryClientProvider client={queryClient}>
          <Router>
            <App />
            <Snackbar />
            <Modals />
          </Router>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </ErrorHandler>
    </UuiContext.Provider>
  );
};

const RoutedApp = () => <UuiEnhancedApp />;
const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<RoutedApp />);
